import { render, staticRenderFns } from "./ConnectThePuzzlesPreview.vue?vue&type=template&id=5fc2b7da&lang=pug&"
import script from "./ConnectThePuzzlesPreview.vue?vue&type=script&lang=js&"
export * from "./ConnectThePuzzlesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports